import { render, staticRenderFns } from "./addDigitude.vue?vue&type=template&id=32743d8b&scoped=true"
import script from "./addDigitude.vue?vue&type=script&lang=js"
export * from "./addDigitude.vue?vue&type=script&lang=js"
import style0 from "./addDigitude.vue?vue&type=style&index=0&id=32743d8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32743d8b",
  null
  
)

export default component.exports